var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "ul",
        {
          staticClass: "nav nav-tabs nav-fill",
          class: [_vm.subMenu ? "sub-menu" : ""],
          attrs: { role: "tablist" }
        },
        _vm._l(_vm.tabs, function(tab) {
          return _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                class: {
                  active: _vm.activeTabName === tab.name,
                  disabled: tab.isDisabled
                },
                attrs: { role: "tab" },
                on: {
                  click: function($event) {
                    return _vm.selectTab(tab)
                  }
                }
              },
              [_vm._v(_vm._s(tab.label))]
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm._l(_vm.renderedTabs, function(ref) {
        var name = ref.name
        return _c(
          "div",
          {
            staticClass: "tab-content",
            class: { hidden: name !== _vm.activeTabName }
          },
          [_vm._t(name)],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }